import loadable from '@loadable/component'

export const MfeTabCollection = loadable(() => import('./MfeTabCollection'))
export type { TabMainContent } from './MfeTabCollection'
